import PatientResultsTable from './PatientResultsTable';

export default PatientResultsTable;
